import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation} from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {TyreValuesService} from '@shared/service/tyre-values.service';
import {Utilities} from '@shared/utilities/utilities.model';
import {VehicleNature} from '../../../claims/claims-commons/models/vehicle.model';
import {ImpactPointTypes} from '@shared/enums/impact-point-types.enum';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
    selector: 'amd-tire-impact-point',
    templateUrl: './tire-impact-point.component.html',
    styleUrls: ['./tire-impact-point.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [TyreValuesService]
})

export class TireImpactPointComponent implements OnChanges {
    @Input() nature: VehicleNature;
    @Input() impactPoints: ImpactPointTypes[] = [];
    @Input() canEdit: boolean;
    @Output() onPointsChange: EventEmitter<ImpactPointTypes[]> = new EventEmitter();

    form: FormGroup;

    get tireNumber(): number {
        return this.nature === VehicleNature.VAN ? 6 : this.nature === VehicleNature.MOTORVEHICLE ? 4 : 2;
    }

    get formControls(): FormArray {
        return <FormArray>this.form.controls['tires'];
    }

	translateContext = TranslateContext;

    constructor(private fb: FormBuilder, private tyreValuesService: TyreValuesService) {
        this.form = this.fb.group({tires: this.fb.array([])});
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.nature && changes.nature.currentValue) {
            this.form.controls['tires'] = this.fb.array([]);
            const tiresArray = (this.form.controls['tires'] as FormArray);
            const model = this.getWheelsModel();
            if (!Utilities.isVoid(model)) {
                for (let i = 0; i < this.tireNumber; i++) {
                    const axis = model[i].axis === this.tyreValuesService.AXIS_1 ? 'FRONT' : 'REAR';
                    const side = model[i].side !== this.tyreValuesService.SIDE_CN ? (model[i].side === this.tyreValuesService.SIDE_DX ? '_R' : '_L') : '';
                    const position = model[i].position === this.tyreValuesService.POSITION_INT ? '_INT' : '';
                    tiresArray.push(this.initGroup(model[i].axis, model[i].side, model[i].position, ImpactPointTypes[axis + side + position]));
                }
            }
        }
    }

    initGroup(axis: string, side: string, position: string, impactPointType: ImpactPointTypes): FormGroup {
        return this.fb.group({
            position: [position],
            side: [side],
            axis: [axis],
            impactPointType: [impactPointType]
        });
    }

    setPoint(impactPointType): void {
        this.impactPoints.push(impactPointType);
        this.onPointsChange.emit(this.impactPoints);
    }

    clearPoint(impactPointType): void {
        this.impactPoints.splice(this.impactPoints.indexOf(impactPointType), 1);
        this.onPointsChange.emit(this.impactPoints);
    }

    isActive(impactPointType): boolean {
        return this.impactPoints.indexOf(impactPointType) > -1;
    }

    onClickSelectTire(impactPointType: ImpactPointTypes): void {
        if (this.isActive(impactPointType)) {
            this.clearPoint(impactPointType);
        } else {
            this.setPoint(impactPointType);
        }
    }

    private getWheelsModel(): { axis: string, side: string, position: string }[] {
        switch (this.tireNumber) {
            case 2:
                return this.tyreValuesService.twoWheels;
            case 3:
                return this.tyreValuesService.threeWheels;
            case 4:
                return this.tyreValuesService.fourWheels;
            case 6:
                return this.tyreValuesService.sixWheels;
            default:
                return null;
        }
    }
}
